// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__gFa5H","consentsList":"PatientConsents_consentsList__2UsDF","consentsListEmpty":"PatientConsents_consentsListEmpty__kNfXM"};